export default [
  {
    value: 1,
    color: '#4CAF50'
  },
  {
    value: 2,
    // color: '#FFAB00'
    color: '#FF2528'
  },
  {
    value: 3,
    // color: '#FF2528'
    color: '#FFAB00'
  },
  {
    value: 4,
    color: '#6F6F6F'
  }
]
